import { render, staticRenderFns } from "./Personalizar.vue?vue&type=template&id=5b5b266e&scoped=true&"
import script from "./Personalizar.vue?vue&type=script&lang=js&"
export * from "./Personalizar.vue?vue&type=script&lang=js&"
import style0 from "./Personalizar.vue?vue&type=style&index=0&id=5b5b266e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b266e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VBadge,VBtn,VCard,VCombobox,VContainer,VDialog,VFlex,VIcon,VLayout,VListTileContent,VProgressCircular,VSelect,VToolbar})
